import { __rest, __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { ButtonBase } from './ButtonBase/index.js';
import { ButtonBody } from './ButtonBody/index.js';

var Button = forwardRef(function (_a, ref) {
    var children = _a.children, iconLeft = _a.iconLeft, iconRight = _a.iconRight, _b = _a.look, look = _b === void 0 ? "primary" : _b, _c = _a.size, size = _c === void 0 ? "md" : _c, _d = _a.tone, tone = _d === void 0 ? "primary" : _d, _e = _a.themeKey, themeKey = _e === void 0 ? "buttons" : _e, _f = _a.rounded, rounded = _f === void 0 ? false : _f, props = __rest(_a, ["children", "iconLeft", "iconRight", "look", "size", "tone", "themeKey", "rounded"]);
    var iconSize = look === "link" ? "inherit" : size;
    return (jsx(ButtonBase, __assign({ ref: ref, themeKey: themeKey, look: look, size: size, tone: tone, rounded: rounded }, props, { children: jsx(ButtonBody, __assign({ iconLeft: iconLeft, iconRight: iconRight, size: iconSize }, { children: children })) })));
});
Button.displayName = "Button";

export { Button };
//# sourceMappingURL=Button.js.map
